import { TaskNotificationFooterDateAndType } from "./TaskNotificationFooterDateAndType";
import { ComponentNotificationFooter } from "./types/task-notification.types";

interface TaskNotificationFooterProps {
  component: ComponentNotificationFooter;
  createdAt: string;
}
export const TaskNotificationFooter = ({
  component,
  createdAt,
}: TaskNotificationFooterProps) => {
  const { type } = component;
  switch (type) {
    case "notification-footer":
      return (
        <TaskNotificationFooterDateAndType
          {...component}
          createdAt={createdAt}
        />
      );
  }
};
